export default "__VITE_ASSET__87603aba__"